import React from 'react';
// import Box from '@mui/material/Box';
// import Collapse from '@mui/material/Collapse';
// import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
// import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
// import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
// import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import './Table.css'
// import axios from "axios";
// import Moment from "moment/moment";
// import {useAuthHeader} from "react-auth-kit";

function createData(
    name: string,
    calories: number,
    fat: number,
    carbs: number,
    protein: number,
    price: number,
) {
    return {
        name,
        calories,
        fat,
        carbs,
        protein,
        price,
        details: [
            {
                date: '18\u00A0Mar',
                tour: 'VAT',
                service: 160,
                reviews: 30,
                onsite: -30,
                others: 0,
                total: 190,
            },
            {
                date: '17\u00A0Mar',
                tour: 'VAT',
                service: 160,
                reviews: 10,
                onsite: -10,
                others: 0,
                total: 170,
            },
            {
                date: '16\u00A0Mar',
                tour: 'VAT',
                service: 160,
                reviews: 0,
                onsite: -10,
                others: 0,
                total: 160,
            },
            {
                date: '15\u00A0Mar',
                tour: 'VAT',
                service: 160,
                reviews: 50,
                onsite: -10,
                others: 0,
                total: 210,
            },
        ],
    };
}

function Row(props: { row: ReturnType<typeof createData>, isPaid: boolean, guide: any}, isUpcoming2: boolean) {
    const {guide} = props;
    const [open, setOpen] = React.useState(false);

    console.log("guide", guide)
    return (
        <React.Fragment>
            <TableRow
                sx={{'& > *': {borderBottom: 'unset'}}}
                onClick={() => setOpen(!open)}
                style={{cursor: "pointer"}}
            >
                <TableCell component="th" scope="row">
                    {guide}
                </TableCell>
                {/*<TableCell align="center">123</TableCell>*/}
                {/*<TableCell align="center">23</TableCell>*/}
                {/*<TableCell align="center">5</TableCell>*/}
                {/*<TableCell align="center">1</TableCell>*/}
                {/*<TableCell align="center">0</TableCell>*/}
                <TableCell align="center">4.95</TableCell>
                <TableCell align="center">189</TableCell>
                <TableCell align="center">432</TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default function GuidesTable({rows, isPaid, guideList}) {

    return (
        <>
            <div style={{margin: "50px 0px 20px 0px"}}>
                <h5>Owner view</h5>
            </div>
            {rows.length > 0 ?
                <TableContainer component={Paper}>
                    <Table aria-label="collapsible table">
                        <TableHead>
                            <TableRow>
                                {/*<TableCell/>*/}
                                <TableCell align="center">Guide</TableCell>
                                {/*<TableCell align="center">5*</TableCell>*/}
                                {/*<TableCell align="center">4*</TableCell>*/}
                                {/*<TableCell align="center">3*</TableCell>*/}
                                {/*<TableCell align="center">2*</TableCell>*/}
                                {/*<TableCell align="center">1*</TableCell>*/}
                                <TableCell align="center">Total reviews</TableCell>
                                <TableCell align="center">Year avg rating</TableCell>
                                <TableCell align="center">Year avg earning</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((guide) => (
                                <Row key={guide.name} guide={guide} isPaid={isPaid}/>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                :
                <div>list empty</div>
            }
        </>
    );
}

